import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class Courier extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/courier`)
  }

  approve(id, showProgress) {
    return this._request({
      action: `${id}/approve`,
      method: 'PATCH',
      showProgress
    })
  }

  updateRoles(id, model, showProgress) {
    return this._request({
      action: `${id}/role`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  updateGateway(id, model, showProgress) {
    return this._request({
      action: `${id}/gateway`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  brief(id, showProgress) {
    return this._request({
      action: `${id}/brief`,
      method: 'GET',
      showProgress
    })
  }

  blackList(id, model, showProgress) {
    return this._request({
      action: `${id}/blackList/set`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  revertBlackList(id, showProgress) {
    return this._request({
      action: `${id}/blackList/unset`,
      method: 'PATCH',
      showProgress
    })
  }
}
